import React from "react";

export const SimpleText = ({children}) => {
  return (
    <span>{children}</span>
  );
};
